import {request} from '../../helpers/request'
import {Grid, Row, Col} from 'react-bootstrap'
import React from 'react'
import {Table} from 'react-bootstrap'
import _ from 'lodash'
import {t} from '../../helpers/translate.js'
import axios, { post } from 'axios';
let config = require('config');

class AttachmentComponent extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      data: '',
      value: '',
      attachment: '',
      description: '',
      files: null,
      selectedFile: null,
      saving: false,
    };
  }

  renderAttachments (){
    return (
      <tbody>
      {this.props.attachments.map(
        (attachment, index) => {
          var session_data = JSON.parse(attachment.user_data).session_data;

          return (
            <tr key={index}>
              {this.renderTableCell(`${session_data.first_name} ${session_data.last_name}`)}
              {this.renderTableCell(attachment.created_at)}
              {this.renderTableCell(attachment.description)}
              {this.renderDownloadCell(attachment.link)}
            </tr>
          )
        })}
      </tbody>
    )
  }

  handleDescriptionChange(event) {
    this.setState({
      description: event.target.value
    });
  }

  getS3TemporaryLink(link) {
    let succ = true;
    request(`${config.default.api}/getS3TempLink/${link}`,
      'GET',
      null,
      function (data, status) {
        if (status == 200) {
          if(succ){
            window.open(data.signed_url, "_blank");
          }
        }
      }.bind(this),
      { 'Content-Type': 'application/json'}
    );
  }

  renderDownloadCell(link) {
    return <td>
      <button 
        className="btn button-primary" 
        onClick={this.getS3TemporaryLink.bind(this, link)} 
      >
        Download File
      </button>
    </td>
  }

  renderTableCell (value) {
    return <td>{value}</td>
  }

  handleFileSelection(event) {
    event.preventDefault();
    let files = event.target.files
    this.setState({attachmentName: files[0].name})
  }

  handleUpload = (ev) => {
    this.props.showLoading('Uploading');
    let file = this.uploadInput.files[0];

    if (file === undefined) {
      this.setState({errorMessage: 'A file must be uploaded'})
      return { 'Error': 'A file must be uploaded'};
    }

    // Split the filename to get the name and type
    const fileParts = this.uploadInput.files[0].name.split('.');
    const fileType = fileParts[1];

    // Get the Signed URL
    request(`${config.default.api}/signS3/${this.props.applicationId}/${this.uploadInput.files[0].name}`,
      'GET',
      null,
      function (data, status) {
        if (status == 200) {
          const signedRequest = data.signed_url;
          const filePath = data.file_path;

          const options = {
            headers: {
              'Content-Type': fileType,
            }
          };

          axios.put(signedRequest, file, options)
          .then(result => {
            this.saveAttachmentData(filePath);
          })

          event.preventDefault();

        } else {
          this.props.showModal('Error', 
            <div>
              {data.messages.map((message) => <p>{message}</p>)}
            </div>
          );
          event.preventDefault();
        }
        this.props.hideLoading();
      }.bind(this),
      { 'Content-Type': 'application/json'}
    );
  }

  saveAttachmentData(filePath) {
    (this.state.description.length > 0) && request(`${config.default.api}/attachment/${this.props.source}/${this.props.applicationId}`,
      'POST',
      { 
        'description': this.state.description,
        'attachmentName': this.state.attachmentName,
        'applicationId': this.props.applicationId,
        'link': filePath
      },
      function (data, status) {
        if (status == 200) {
          this.setState({
            description: '',
            attachmentName: ''
          })
          this.uploadInput.value = '';
          
          this.props.showModal('Success', 'The attachment has been added');
        } else {
          this.props.showModal('Error', 
            <div>
              {data.messages.map((message) => <p>{message}</p>)}
            </div>
          );
        }
      }.bind(this),
      {
        'Content-Type': 'application/json'
      }
    );
  }

  render() {
    const tableHead = [t('User'), t('Date/Time'), t('Description'), t('Link') ];
    
    return <div>
      {
        this.props.canUserAddAttachment &&
        <Grid>
          <Row>
            <Col sm={4}>
              <input
                type='file'
                label='File' 
                onChange={this.handleFileSelection.bind(this)}
                ref={(ref) => { this.uploadInput = ref; }}
              />
            </Col>
            <Col sm={8}>
              {t('Descriptions')}: <input type="text" onChange={this.handleDescriptionChange.bind(this)} 
              value={this.state.description}
              />
            </Col>
          </Row>
          <Row>
            <button 
              className="btn button-secondary" 
              onClick={this.handleUpload.bind(this)} 
              disabled={this.state.description.length == 0}
            >
            {t('Add Attachment')}
            </button>
          </Row>
        </Grid>
      }
      {
        this.props.attachments.length > 0 &&
        <Table striped condensed hover id='attachmentTable'>
          <thead>
            <tr>
            {tableHead.map((th, index) => <th key={index}>{t(th)}</th>)}
            </tr>
          </thead>
          { this.renderAttachments() }
        </Table>
      }
    </div>
  }
}
AttachmentComponent.displayName = 'AttachmentComponent';
export default AttachmentComponent;



// WEBPACK FOOTER //
// ./src/components/common/AttachmentComponent.js